import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@design-system';

interface PartnerInviteAcknowledgeDialogProps {
  open: boolean;
  inviteeName: string;
  isSending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function PartnerInviteAcknowledgeDialog({
  open,
  inviteeName,
  isSending,
  onConfirm,
  onCancel,
}: PartnerInviteAcknowledgeDialogProps) {
  const who = inviteeName.trim() || 'this person';

  return (
    <Dialog
      open={open}
      onOpenChange={isOpen => !isOpen && !isSending && onCancel()}
    >
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-primary-dark">
            How sharing works with invited partners
          </DialogTitle>
          <DialogDescription className="text-foreground">
            {who} doesn't have a Waterlily account yet, so they need to create one first.
            <br />
            Once they do, your client data will automatically be shared with them as your
            distribution partner — based on the consent your clients give at intake.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={onCancel}
            disabled={isSending}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isSending}
          >
            {isSending ? 'Sending…' : 'Acknowledge & send invite'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
